
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/[id]",
      function () {
        return require("private-next-pages/project/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/[id]"])
      });
    }
  